<template>
  <div class="location-fields">
    <div v-show="!company.remote">
      <div
        class="location-field"
        v-for="(location, index) in company.locations"
        v-model="company.locations"
        :key="location.id || index"
      >
        <template v-if="location.hq">
          <locationField
            class="location-input hq"
            :model="`company[locations_attributes][${index}]`"
            attribute="address"
            placeholder="Enter your headquarters location"
            :required="!company.remote"
            v-model="location.address"
          />

          <div class="hq-label" v-show="company.locations.length > 1">
            Headquarters
          </div>
        </template>

        <template v-else>
          <div v-show="!location._destroy">
            <locationField
              class="location-input"
              :model="`company[locations_attributes][${index}]`"
              attribute="address"
              placeholder="Enter another location"
              v-model="location.address"
            />

            <div class="location-controls location-controls--remove small-icon-btn">
              <span class="ss-icon is-big">minus</span>
              <p class="remove-location" @click="location._destroy = 1">Remove location</p>
            </div>
          </div>
        </template>


        <input
          v-for="key in ['index', 'id', 'address', 'hq']"
          :key="key"
          type="hidden"
          :value="location[key]"
          :name="`company[locations_attributes][${index}][${key}]`">
        <input
          type="hidden"
          :value="location._destroy || company.remote"
          :name="`company[locations_attributes][${index}][_destroy]`">
      </div>

      <div class="location-controls small-icon-btn">
        <span class="ss-icon is-big">plus</span>
        <a class="add-location" @click="addLocation">Add another location</a>
      </div>

      <hr class="locations_rule" />
    </div>

    <div class="remote-checkboxes">
      <div class="cm-field cm-radio-field">
        <label class="cm-label remote">
          <input
            type="checkbox"
            name="company[remote]"
            :checked="company.remote"
            @change="toggleRemote"
          />
          <input
            name="company[remote]"
            type="hidden"
            :value="company.remote"
          />
          {{ I18n.t('activerecord.attributes.company.remote') }}
        </label>
      </div>

      <div class="cm-field cm-radio-field">
        <label class="cm-label remote">
          <input
            type="checkbox"
            name="company[remote_employees]"
            :checked="company.remote_employees"
            @change="toggleRemoteEmployees"
          />
          <input
            name="company[remote_employees]"
            type="hidden"
            :value="company.remote_employees"
          />
          {{ I18n.t('activerecord.attributes.company.remote_employees') }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
  import locationField from './location-field'

  export default {
    props: {
      company_data: {
        required: true
      }
    },

    data: function () {
      let company = JSON.parse(this.company_data)
      company.locations = company.locations.map((l, i) => ({
        ...l,
        _destroy: 0,
        index: i,
      }))

      return {
        company,
      }
    },

    components: {
      locationField
    },

    mounted() {
      if (this.company.locations.length < 1) {
        this.addLocation({ hq: true });
      }
    },

    watch: {
      company: {
        handler: function() {
          let index = 0;

          this.company.locations.forEach((location, i) => {
            if (!location._destroy) {
              this.company.locations[i].index = index
              index++
            } else {

            }
          });
        },
        deep: true,
      }
    },

    methods: {
      addLocation(options) {
        this.company.locations.push({
          address: '',
          _destroy: false,
          ...options
        });
      },

      toggleRemote(e) {
        this.company.remote = e.target.checked;

        if (e.target.checked === true) {
          this.company.remote_employees = false;
        }
      },

      toggleRemoteEmployees(e) {
        this.company.remote_employees = e.target.checked;

        if (e.target.checked === true) {
          this.company.remote = false;
        }
      },
    }

  }
</script>

<style lang="scss" scoped>

  .location-field {
    margin-bottom: 1rem;
  }

  .location-input {
    &.hq {
      margin-bottom: 0;
    }
  }

  .hq-label {
    @extend %b3;
    margin: 0.25rem 0;
    color: var(--fg-2);
  }

  .location-controls {
    display: flex;
    align-items: center;
    height: $gutter;

    &--remove {
      justify-content: flex-end;
    }
  }

  .remove-location {
    float: right;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// app/javascript/components/location-fields.vue?92c71dda